module.exports = __webpack_public_path__ + "static/media/microsoftPowerpoint.0e97c564.svg";